import { useConfigContext } from "@entities/game/model/useConfigContext.ts";
import { Center, Container, Image } from "@mantine/core";
import React from "react";

export const DiscordQr = () => {
	const { gameConfig } = useConfigContext();
	const qr = gameConfig?.PublicWebClientConfig.Links?.DiscordQrCodeImageUrl;

	if (!qr) return null;
	return (
		<Container style={{ width: "100vmin" }}>
			<Center>
				<Image src={qr} />
			</Center>
		</Container>
	);
};
